module.exports = __webpack_public_path__ + "static/media/image-error.db30080a.png";